import React from 'react';
import AnalysisDisplay from '../AnalysisDisplay';
import './AnalysisModal.css';

interface AnalysisModalProps {
  isOpen: boolean;
  onClose: () => void;
  analysis: any;
  loading: boolean;
}

const AnalysisModal: React.FC<AnalysisModalProps> = ({
  isOpen,
  onClose,
  analysis,
  loading
}) => {
  if (!isOpen) return null;

  return (
    <div className="analysis-modal-overlay">
      <div className="analysis-modal-content" onClick={onClose}>
        <div className="analysis-modal-header">
          <h2>Bag Score</h2>
          <button onClick={onClose} className="close-button">&times;</button>
        </div>
        <div className="analysis-modal-body">
          <AnalysisDisplay analysis={analysis} loading={loading} />
        </div>
      </div>
    </div>
  );
};

export default AnalysisModal;
